// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const Language = createSvgIcon(
  { LeftToRight: <React.Fragment><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 8c0 3.866-3.134 7-7 7a6.983 6.983 0 01-2.528-.4704L1 15l.5-4.3969C1.1775 9.7984 1 8.9199 1 8c0-3.866 3.134-7 7-7s7 3.134 7 7z" /><circle cx="8" cy="8" r="4" stroke="currentColor" strokeWidth="2" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 5.5S6 6.9606 8 7c2 .0394 3-1.5 3-1.5M11 10.5007s-1-1.4605-3-1.5c-2-.0394-3 1.5-3 1.5" /></React.Fragment>, },
  'small'
);
